import { Component, Element, State, h, Host, Method, Prop, Event, EventEmitter } from '@stencil/core';
import { ArrowIcon } from '../../icons';

@Component({
  tag: 'zpr-tabs'
})
export class ZprTabs {
  private _tabsWapper: HTMLElement;

  @Element() el: HTMLElement;

  @Prop() fill?: boolean = false;
  @Prop() isEmpty?: boolean = false;

  @State() tabs: Element[] = [];
  @State() activeTabId: string | null = null;
  @State() isBackwardButtonHidden: boolean = false;
  @State() isFowardButtonHidden: boolean = false;

  @Event({ eventName: 'tabs-change' }) openTab: EventEmitter;

  componentWillLoad() {
    const headersChildren = this.el.children;
    this.tabs = Array.from(headersChildren).filter((child) => !child.hasAttribute('slot'));
    const activeTabs: string[] = [];

    this.tabs.map((tab, idx) => {
      if (tab.classList.contains('active')) {
        this.activeTabId = idx.toString()
      }
      const disabled = tab.hasAttribute('data-disabled') ? tab.getAttribute('data-disabled') : tab.getAttribute('disabled');
      if (!disabled || disabled == null) {
        activeTabs.push(idx.toString())
      }
    })

    if (this.activeTabId === null) {
      this.activeTabId = activeTabs[0];
      this.tabs[this.activeTabId].classList.add('active')
    }
  }

  componentDidLoad() {
    window.onresize = () => this.checkScrollerButtonHidden()
  }

  componentDidRender() {
    if (this.el.children.length <= 1) return;
    this.checkScrollerButtonHidden()
    if (this.activeTabId) {
      this.centerActiveTabButton()
    }
  }

  @Method()
  async addTab(title: string) {
    const tab = document.createElement('div')
    tab.setAttribute('tab-header', title)
    this.tabs = [...this.tabs, tab]
  }

  @Method()
  async removeTab(title: string) {
    const tabs = this.tabs.filter((tab: any) => {
      return tab.getAttribute('tab-header') != title
    });
    this.tabs = [...tabs];
  }

  @Method()
  async getTabHeaders() {
    return [...this.tabs.map((header, idx) => header.getAttribute('tab-header'))]
  }

  @Method()
  async updateTabs() {
    this.tabs = [...this.tabs]
  }

  @Method()
  async selectTab(tabId: string) {
    this.activateTab(tabId)
    this.openTab.emit({ "id": tabId })
  }

  @Method()
  async activateTab(tabId: string) {
    for (const [idx, tabContent] of this.tabs.entries()) {
      if (idx.toString() === tabId) {
        tabContent.classList.add('active');
      } else {
        tabContent.classList.remove('active');
      }
    }
    this.activeTabId = tabId

    this.centerActiveTabButton()
  }

  @Method()
  async getActivateTab() {
    return this.activeTabId
  }

  headerClickHandler(ev: Event) {
    const targetBtn = ev.target as HTMLElement;
    this.activateTab(targetBtn.getAttribute('tab-id'))
    const tabLink = targetBtn.getAttribute('tab-link')
    if (tabLink) { this.goToTabLink(tabLink) }
  }

  renderButton(headerTitle: string, disabled: string, idx: number, tabLink: string | null) {
    return (
      <button
        tab-id={idx}
        tab-link={tabLink}
        class={`btn btn-ghost ${(this.activeTabId === idx.toString() || idx === 0 && this.activeTabId === null) ? 'active' : ''} `}
        disabled={disabled === 'true' ? true : false}
        onClick={ev => {
          this.headerClickHandler(ev)
          this.openTab.emit({ "id": idx, "link": tabLink, "label": headerTitle })
        }}>{headerTitle}
      </button>
    )
  }

  goToTabLink(tabLink: string) {
    window.location.href = tabLink
  }

  slide(direction: string) {
    if (direction == 'backward') {
      this._tabsWapper.scrollLeft -= 100;
    } else {
      this._tabsWapper.scrollLeft += 100;
    }
  }

  centerActiveTabButton() {
    if (!this._tabsWapper) return;
    const activeTabButton = this.el.querySelector(`[tab-id="${this.activeTabId}"]`) as HTMLElement
    const tabHeader = this.el.querySelector('.tab-header') as HTMLElement
    const widthOfHostEl = this.el.offsetWidth || tabHeader.offsetWidth;
    this._tabsWapper.scrollLeft = activeTabButton.offsetLeft - (widthOfHostEl / 2) + (activeTabButton.offsetWidth / 2)
  }

  checkScrollerButtonHidden() {
    if (!this._tabsWapper) return;
    const isLeftMost = this._tabsWapper.scrollLeft === 0
    const maxScrollLeft = this._tabsWapper.scrollWidth - this._tabsWapper.clientWidth
    const isRightMost = this._tabsWapper.scrollLeft >= maxScrollLeft - 1
    this.isFowardButtonHidden = isRightMost
    this.isBackwardButtonHidden = isLeftMost
  }

  render() {
    return (
      <Host>
        <div class='tab-header'>
          {this.el.children.length <= 1 ? null : [
            <button class={`scroller scroll-backward ${this.isBackwardButtonHidden ? 'hidden' : ''}`} onClick={() => this.slide('backward')}><ArrowIcon /></button>,
            <button class={`scroller scroll-forward ${this.isFowardButtonHidden ? 'hidden' : ''}`} onClick={() => this.slide('forward')}><ArrowIcon /></button>,
            <div class='tabs-wrapper' ref={(el) => this._tabsWapper = el} onScroll={() => this.checkScrollerButtonHidden()}>
              {this.tabs.map((header, idx) => {
                const disabled = header.hasAttribute('data-disabled') ? header.getAttribute('data-disabled') : header.getAttribute('disabled');
                return this.renderButton(header.getAttribute('tab-header'), disabled, idx, header.getAttribute('tab-link'))
              })}
              <slot name="header"></slot>
            </div>
          ]}
        </div>
        {this.isEmpty ? null : (
          <div class={{
            "tab-content": true,
            "tab-white": this.fill
          }}>
            <slot />
          </div>
        )}
      </Host>
    )
  }
}